import {COUNTRY_CODES} from '@chekin/core';

const RECENT_COUNTRIES_STORAGE_KEY = 'guestapp:recentCountries';

const POPULAR_COUNTRY_CODES = [
  COUNTRY_CODES.spain,
  COUNTRY_CODES.uk,
  COUNTRY_CODES.italy,
  COUNTRY_CODES.france,
  COUNTRY_CODES.germany,
  COUNTRY_CODES.usa,
  COUNTRY_CODES.netherlands,
  COUNTRY_CODES.poland,
  COUNTRY_CODES.portugal,
  COUNTRY_CODES.canada,
  COUNTRY_CODES.ukraine,
  COUNTRY_CODES.romania,
  COUNTRY_CODES.brazil,
  COUNTRY_CODES.austria,
  COUNTRY_CODES.czech,
  COUNTRY_CODES.china,
  COUNTRY_CODES.ireland,
  COUNTRY_CODES.switzerland,
  COUNTRY_CODES.argentina,
  COUNTRY_CODES.mexico,
  COUNTRY_CODES.colombia,
  COUNTRY_CODES.belgium,
  COUNTRY_CODES.australia,
  COUNTRY_CODES.morocco,
  COUNTRY_CODES.sweden,
  COUNTRY_CODES.hungary,
  COUNTRY_CODES.turkey,
  COUNTRY_CODES.denmark,
  COUNTRY_CODES.russia,
  COUNTRY_CODES.india,
  COUNTRY_CODES.israel,
  COUNTRY_CODES.southKorea,
  COUNTRY_CODES.norway,
  COUNTRY_CODES.slovakia,
  COUNTRY_CODES.venezuela,
  COUNTRY_CODES.bulgaria,
  COUNTRY_CODES.lithuania,
  COUNTRY_CODES.greece,
  COUNTRY_CODES.saudiArabia,
  COUNTRY_CODES.peru,
];

export {RECENT_COUNTRIES_STORAGE_KEY, POPULAR_COUNTRY_CODES};
